module.exports = {"private":true,"main":"./ProgressBar.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/frags/ProgressBar/package.json
// module id = 843
// module chunks = 0 1